//Make a request to the backend to transfer the ownership of the webhook to the user
import simbApi from ".";
import { TRANSFER_WEBHOOK_OWNERSHIP } from "../../data/constants/endpoints";
import logger from "../../lib/logger";

export const postTransferOwnerShip = async (
  webhookEvent: string,
  userId: string,
  accountId: string,
  boardId: number,
  token: string,
  webhookId?: string,
) => {
  try {
    const response = await simbApi.post(
      TRANSFER_WEBHOOK_OWNERSHIP,
      { webhookEvent, userId, accountId, boardId, webhookId },
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    if (response?.data?.error) {
      throw new Error(response?.data?.error);
    }

    return response.data;
  } catch (error: any) {
    logger.error(error.message);

    throw error;
  }
};
